import { queryOptions } from "@tanstack/react-query";

import { apiGet } from "@softmax/observatory-client/client";

import type { Schemas } from "@softmax/observatory-client/types";
import { viewerProgress } from "@/data/viewer-progress";

export const viewerProgressQueryOptions = (viewerId: string | null) =>
  queryOptions({
    queryKey: ["viewer", viewerId, "progress", { elevatedPrivileges: false }],
    queryFn: ({ signal }) => viewerProgress({ signal }),
    enabled: viewerId !== null,
    staleTime: 30_000,
  });

export const championEpisodesQueryOptions = (policyVersionId: string) =>
  queryOptions({
    queryKey: [
      "viewer",
      "champion-episodes",
      { policyVersionId, limit: 25, elevatedPrivileges: false },
    ],
    queryFn: ({ signal }) =>
      apiGet<Schemas["EpisodePage"]>(
        `/v2/policy-versions/${encodeURIComponent(policyVersionId)}/episodes?limit=25`,
        { signal, elevatedPrivileges: false },
      ),
    staleTime: 30_000,
  });
